import { ChevronLeft, Map, MapPin } from 'lucide-react'
import { useAppStore } from '@/store/app'

interface Props {
  onBack: () => void
}

export default function SettingsPage({ onBack }: Props) {
  const { mapsEnabled, setMapsEnabled } = useAppStore()

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-center gap-3">
        <button onClick={onBack} className="btn-ghost p-2">
          <ChevronLeft className="w-5 h-5" />
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Preferences</h1>
      </div>

      {/* Maps Section */}
      <div className="card p-6 space-y-4">
        <div className="flex items-center gap-2 mb-1">
          <Map className="w-5 h-5 text-brand-600" />
          <h2 className="text-lg font-semibold text-gray-900">Map Features</h2>
        </div>

        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <MapPin className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
            <div>
              <p className="text-sm font-medium text-gray-800">Enable Nearby Store Search</p>
              <p className="text-xs text-gray-500 mt-0.5">
                When enabled, MealMap can use your location to find nearby grocery stores via
                Google Maps. Disable this to prevent any map or location API activity.
              </p>
            </div>
          </div>

          {/* Toggle */}
          <button
            onClick={() => setMapsEnabled(!mapsEnabled)}
            aria-label={mapsEnabled ? 'Disable maps' : 'Enable maps'}
            className={`relative flex-shrink-0 w-12 h-6 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2 ${
              mapsEnabled ? 'bg-brand-600' : 'bg-gray-300'
            }`}
          >
            <span
              className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${
                mapsEnabled ? 'translate-x-6' : 'translate-x-0'
              }`}
            />
          </button>
        </div>

        {!mapsEnabled && (
          <p className="text-xs text-amber-600 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
            Maps are disabled. The "Find nearby stores" feature will be hidden in the shopping list.
          </p>
        )}
      </div>
    </div>
  )
}
